var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 37766",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 140602",
    width: 22,
    height: 22,
    rx: 11,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37766",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48195",
    d: "M17.749 22.172H4.423A4.423 4.423 0 0 1 0 17.749V4.423A4.423 4.423 0 0 1 4.423 0h13.326a4.423 4.423 0 0 1 4.423 4.423v13.326a4.423 4.423 0 0 1-4.423 4.423",
    fill: "#ba2b26"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48196",
    d: "M16.249 15.302c.428.42.856.824 1.265 1.247a.667.667 0 0 1-.04 1.039.852.852 0 0 1-.459.145c-2.054.009-4.109.022-6.163 0a6.627 6.627 0 1 1 5.4-2.434m-9.126-4.224a3.954 3.954 0 1 0 3.962-3.949 3.978 3.978 0 0 0-3.962 3.949",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuora);
export default __webpack_public_path__ + "static/media/Quora.c0df130a81019056c5ac64f87042215e.svg";
export { ForwardRef as ReactComponent };